import { render, staticRenderFns } from "./QrCodeTile.vue?vue&type=template&id=00350bcf&"
import script from "./QrCodeTile.vue?vue&type=script&lang=ts&"
export * from "./QrCodeTile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports